import '.br{text-align:center;}.ssr-plugin'
import { useState, useEffect } from 'react'
import { Text } from './Text'
import { styled } from 'inlines'

type CountdownTimerProps = {
  targetTimestamp: number
}

const formatTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return { days, hours, minutes, seconds }
}

export const CountdownTimer = ({ targetTimestamp }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const remaining = targetTimestamp - Date.now()
    return remaining > 0 ? remaining : 0
  })

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = targetTimestamp - Date.now()
      if (remaining <= 0) {
        setTimeLeft(0)
        clearInterval(interval)
      } else {
        setTimeLeft(remaining)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [targetTimestamp])

  const { days, hours, minutes, seconds } = formatTime(timeLeft)

  return (
    <div className="br">
      <Text as="h2" variant="title" color="gradient">
        {`${String(days).padStart(2, '0')}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`}
      </Text>
    </div>
  )
}

CountdownTimer.displayName = 'CountdownTimer'
